import React from 'react'
import {Box, Card, CardContent, Stack, Typography} from '@mui/material'
import {useAuth} from './auth/auth'
import {RouteSecurity} from './common/RouteSecurity'
import {DashboardLinkCard} from './common/ui'

function InventorySection() {
    const {getPermissions} = useAuth()
    let routeSecurity = new RouteSecurity(getPermissions())

    return (
        <Stack sx={{
            backgroundColor: 'whitesmoke',
            minWidth: '400px',
            borderRadius: 2,
            padding: '16px',
            paddingBottom: '24px',
        }} useFlexGap spacing={2}>
                <Typography variant="h5">Inventory</Typography>
                <DashboardLinkCard
                    route="/inventory/receive"
                    title="Receive"
                    text="Track and receive packages and hand-to-hand transfers"
                />
                <DashboardLinkCard
                    route="/inventory/counts"
                    title="Count"
                    text="Conduct, manage, and review counts"
                />
                <DashboardLinkCard
                    route="/inventory/transfers"
                    title="Transfer Requests"
                    text={routeSecurity.isAuthorized('/inventory/transfer-requests/manage') ?
                        'Manage transfer requests'
                        : 'Request a transfer and see pending transfer requests' }
                />
        </Stack>
    )
}

function OrdersSection() {
    return (
        <Stack sx={{
            backgroundColor: 'whitesmoke',
            minWidth: '400px',
            borderRadius: 2,
            padding: '16px',
            paddingBottom: '24px',
        }}>
                <Typography variant="h5">Orders</Typography>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        '&:hover': {
                            backgroundColor: 'whitesmoke',
                            border: 3,
                            borderColor: 'primary.main',
                        },
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        '&:hover': {
                            backgroundColor: 'whitesmoke',
                            border: 3,
                            borderColor: 'primary.main',
                        },
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        '&:hover': {
                            backgroundColor: 'whitesmoke',
                            border: 3,
                            borderColor: 'primary.main',
                        },
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
        </Stack>
    )
}

function FleetManagementSection() {
    return (
        <Card sx={{
            backgroundColor: 'whitesmoke',
            minWidth: '400px',
            borderRadius: 2
        }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>Fleet Management</Typography>
                <Box display="flex" flexDirection="column" justifyContent="flex-start" gap={2}>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{
                        width: '100%',
                        height: 100,
                        borderRadius: 2
                    }}>
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            </CardContent>
        </Card>
    )
}

function AppDashboard() {
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h4" gutterBottom marginTop={3}>Home</Typography>
            <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="center" gap={3} p={3}
                 sx={{mx: 'auto', width: 'full'}}>
                {/*{routeSecurity.isAuthorized('/inventory') && (*/}
                <InventorySection/>
                {/*)}*/}
                {/*{routeSecurity.isAuthorized('/orders') && (*/}
                {/*<OrdersSection />*/}
                {/*)}*/}
                {/*{routeSecurity.isAuthorized('/fleet-management') && (*/}
                {/*<FleetManagementSection />*/}
                {/*)}*/}
            </Box>
        </Box>
    )
}

export default AppDashboard
